// Option Reset is alway need for reset the state when is destroy component
export const MUTATION_TYPES = {
  RESET: 'reset',

  SET_ACADEMIC_YEARS: 'setAcademicYears',
  SET_REGIONS: 'setRegions',
  SET_DISTRICTS: 'setDistricts',
  SET_SCHOOLS: 'setSchools',
  SET_INTERVIEWS: 'setInterviews',
  SET_CURRENT_FILTERS: 'setCurrentFilters',
};

export const ACTION_TYPES = {
  RESET: 'reset',
  GET_BASIC_FILTERS: 'getBasicFilters',
  GET_REGIONS: 'getRegions',
  GET_DISTRICTS: 'getDistricts',
  GET_SCHOOLS: 'getSchools',
  GET_INTERVIEWS: 'getInterviews',
};
